import { Button, Flex, Text } from "@chakra-ui/react"
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core"
import { injected } from "./wallet/connectors"
import { IconContext } from 'react-icons'
import { AiOutlineDisconnect, AiOutlineWarning } from 'react-icons/ai'
import {ethers} from 'ethers'
import { useState } from 'react'

const setNetwork = async () => {
    try {
        await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: ethers.utils.hexValue(137) }] //  137
        });
        
    } catch (err) {
            // This error code indicates that the chain has not been added to MetaMask
            if (err.code === 4902) {
                try{
                    await window.ethereum.request({
                    method: 'wallet_addEthereumChain',
                    params: [
                        {
                        chainName: 'Polygon Mainnet', 
                        chainId: ethers.utils.hexValue(137), 
                        nativeCurrency: { name: 'MATIC', decimals: 18, symbol: 'MATIC' },
                        rpcUrls: ['https://polygon-rpc.com/'] 
                        }
                    ]
                    });
                } catch(e){
                    
                }
            } else {
               
            }
    }
}

if (injected.chainId!=='137') setNetwork().then()      


const WalletSpace = (props) => {
    const { active, activate, deactivate, error, account } = useWeb3React()
    const [unsupportedChain, setUnsupportedChain] = useState(false)
    async function connect() {
        if (injected.chainId!=='137') setNetwork().then() 
        try {
            await activate(injected)
            props.onChange()
        } catch (ex) {
            console.log(ex)
        }
    }

    async function disconnect() {
        console.log(active)
        try {
            deactivate()
            props.onChange()
        } catch (ex) {
            console.log(ex)
        }
        if(props.disconnect) props.disconnect()
    }

    return ( 
        <Flex marginRight={2} >
            {unsupportedChain && <div>
                <Flex alignItems="center" bg="red" rounded="lg" py="1" px="3" >
                    <IconContext.Provider value={{ color: 'white' }}>
                        <AiOutlineWarning />
                    </IconContext.Provider>
                    <Text color="white" fontSize="sm">Switch network to <b>Polygon Mainnet</b></Text>
                </Flex>
            </div>}
            {(account) && 
                <Text fontSize='sm' color='#aaaaaa' marginRight={5} marginTop={2}>{account.substring(0,8)}.....{account.substring(35)}</Text>
            }
            {!active ? <Button onClick={connect}>Connect Wallet</Button>:<Button onClick={disconnect}>Disconnect Wallet</Button>}
        </Flex>
    )

}

export default WalletSpace
